import { GET_STAFF_START } from '../../types';

export const get_staff = (payload) => ({
  type: GET_STAFF_START,
  payload,
});
